import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const GlobalBrandEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const BASE_URL = "https://cyberathon.com/multivendor/";

  const [formData, setFormData] = useState({
    special_offer_image: null,
    brand_logo: null,
    discount: '',
    title: "",
    products: "",
    current_price: "",
    old_price: "",
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch brand by ID
  useEffect(() => {
    const fetchBrand = async () => {
      try {
        setLoading(true);
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/special_offer_by_id",
          { offer_id: id }
        );

        if (response.data.status) {
          const brand = response.data.data;
          setFormData({
            special_offer_image: null,
            brand_logo: null,
            discount: brand.discount,
            title: brand.title,
            products: brand.products,
            current_price: brand.current_price,
            old_price: brand.old_price
          });
          setPreviewImage(`${BASE_URL}${brand.special_offer_image}`);
          setPreviewLogo(`${BASE_URL}${brand.brand_logo}`);
        } else {
          toast.error("Failed to fetch brand details");
          navigate("/Offer");
        }
      } catch (error) {
        console.error("Error fetching brand:", error);
        toast.error("Something went wrong while fetching data");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchBrand();
  }, [id, navigate]);

  // Handle text field
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle file input
  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, [field]: file }));
      if (field === "special_offer_image") setPreviewImage(URL.createObjectURL(file));
      if (field === "brand_logo") setPreviewLogo(URL.createObjectURL(file));
    }
  };

  // Handle submit
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setLoading(true);
    const data = new FormData();
    data.append("offer_id", id);
    if (formData.special_offer_image)
      data.append("special_offer_image", formData.special_offer_image);
    if (formData.brand_logo)
      data.append("brand_logo", formData.brand_logo);
    data.append("discount", formData.discount);
    data.append("title", formData.title);
    data.append("products", formData.products);
    data.append("current_price", formData.current_price);
    data.append("old_price", formData.old_price);

    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_special_offer",
      data,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response.data.status) {
      toast.info("Special Offer updated successfully!");
      navigate("/Offer");
    } else {
      toast.error(response.data.message || "Failed to update Special Offer");
    }
  } catch (error) {
    console.error("Error updating Special Offer:", error);
    toast.error("Something went wrong while updating");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Edit Offer</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item"><a href="#">special offer list</a></li>
            <li className="breadcrumb-item active">Edit</li>
          </ol>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Edit Offer</h4>
            </div>
            <div className="card-body row">
              <div className="col-lg-6 mb-3">
                <label className="form-label">Main Image</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, "special_offer_image")}
                />
                {previewImage && (
                  <img src={previewImage} alt="Preview" height="80" className="mt-2" />
                )}
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Brand Logo</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, "brand_logo")}
                />
                {previewLogo && (
                  <img src={previewLogo} alt="brand_logo" height="80" className="mt-2" />
                )}
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Product Name</label>
                <input
                  type="text"
                  name="products"
                  value={formData.products}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Product Name"
                  required
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Title"
                  required
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Current Price</label>
                <input
                  type="text"
                  name="current_price"
                  value={formData.current_price}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Current Price"
                  required
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Old Price</label>
                <input
                  type="text"
                  name="old_price"
                  value={formData.old_price}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Old Price"
                  required
                />
              </div>


              <div className="col-lg-6 mb-3">
                <label className="form-label">Discount</label>
                <input
                  type="text"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="e.g., 50% Off"
                  required
                />
              </div>
            </div>

            <div className="card-footer">
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Updating..." : "Update Special Offer"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GlobalBrandEdit;
